import React from 'react';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_INFO_KIND,
  TEXT_INFO_HEADING_LEVEL,
  TEXT_INFO_COLOR,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
} from '@gcloud-npm/next12.components.text-info-n';
import IconLabel, {
  ICON_COLOR,
  ICON_LABEL_POSITION,
  ICON_LABEL_FONT_TYPE,
} from '@gcloud-npm/next12.components.icon-label-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import { GetButton } from '@/utils/functions';
import Picture from '@gcloud-npm/next12.components.picture';
import styles from './styles';

export const THEME = {
  GREY: 'GREY',
};

const THEME_LAYOUT = {
  GREY: {
    bgColor: 'grey',
  },
};

const COMPONENT_NAME = 'ModuloFeature';

/**
 * Funcion que devuelve el modulo de las caracteristicas de imagen - texto
 * en la parte de Internet segunda Residencia (ISR)
 */
const ModuloFeatureISR = ({ list, customStyle, theme, taggingInfo }) => {
  const ModuloFeatureTaggingInfo = {
    componentName: COMPONENT_NAME,
    componentProduct: '',
    componentContent: '',
    componentVariation: 'all',
    ...taggingInfo,
  };

  return (
    <>
      <div
        id="moduloFeatureISR"
        className={`moduloFeatureISR ${
          theme && THEME_LAYOUT[theme]
            ? `moduloFeatureISR_bgColor--${THEME_LAYOUT[theme].bgColor}`
            : ''
        }`}
      >
        <div className="container">
          {list.map((item, index) => {
            return (
              <div
                className={
                  customStyle
                    ? `customStyle featureISR align-${item.align}`
                    : `featureISR align-${item.align}`
                }
                key={index.toString()}
              >
                <div className="featureISR-img">
                  <Picture
                    alt={item.altImage}
                    className={item.centerImage && `alignImage`}
                    sources={[
                      {
                        src: item.imgDesktop,
                      },
                    ]}
                  />
                </div>

                <div
                  className={`featureISR-content ${
                    item.textAlign
                      ? `featureISR-content_textAlign--${item.textAlign}`
                      : ''
                  }`}
                >
                  <div className="featureISR-title">
                    {item.title && (
                      <TextInfo
                        kind={TEXT_INFO_KIND.HEADING}
                        level={TEXT_INFO_HEADING_LEVEL.H3}
                        color={TEXT_INFO_COLOR.GREY_6}
                        size={TEXT_INFO_SIZE.TITLE4}
                        text={item.title}
                        fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                        className="title"
                      />
                    )}
                    {item.subtitle && (
                      <TextInfo
                        kind={TEXT_INFO_KIND.HEADING}
                        level={TEXT_INFO_HEADING_LEVEL.H3}
                        color={TEXT_INFO_COLOR.GREY_6}
                        size={TEXT_INFO_SIZE.TITLE4}
                        text={item.subtitle}
                        fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
                        className="subtitle"
                      />
                    )}
                  </div>

                  {item.description && (
                    <div
                      className="featureISR-description"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  )}
                  {item.descriptionList &&
                    item.descriptionList.map((itemList, indexList) => {
                      return (
                        <>
                          <IconLabel
                            key={indexList.toString()}
                            className="featureISR-iconLabel"
                            id={itemList.icon}
                            iconColor={ICON_COLOR.BLUE}
                            iconSize={18}
                            label={itemList.text}
                            labelFont={ICON_LABEL_FONT_TYPE.REGULAR}
                            labelColor={ICON_COLOR.GREY_4}
                            labelPosition={ICON_LABEL_POSITION.RIGHT}
                            labelSize={18}
                          />
                          <br />
                        </>
                      );
                    })}
                  {item.textLink && item.hrefLink && (
                    <CustomLink
                      className="featureISR-link"
                      href={item.hrefLink}
                    >
                      <TextInfo
                        text={item.textLink}
                        kind={TEXT_INFO_KIND.SPAN}
                        color={TEXT_INFO_COLOR.BLUE}
                        size={TEXT_INFO_SIZE.CAPTION1}
                        fontType={TEXT_INFO_FONT_WEIGHT.BOLD}
                      />
                    </CustomLink>
                  )}
                  {item.btnText && (
                    <div className="container-button">
                      {GetButton(item, {
                        componentName: 'ModuloFeatureISRSalud',
                        componentVariation: 'all',
                        componentContent: item.btnText,
                      })}
                    </div>
                  )}
                  {item.showApps &&
                    item.apps &&
                    Array.isArray(item.apps) &&
                    item.apps.length > 0 && (
                      <div className="containerDownloads">
                        {item.apps.map((app) => {
                          if (app.link && app.img) {
                            return (
                              <CustomLink
                                className="containerDownloads-link"
                                href={app.link}
                                title={`Ir a ${app.name}`}
                                ariaLabel={app.name}
                                taggingInfo={{
                                  ...ModuloFeatureTaggingInfo,
                                  componentContent: app.name,
                                }}
                                forceExternal
                                target="_blank"
                              >
                                <Picture
                                  alt={app.name}
                                  sources={[
                                    {
                                      src: app.img,
                                    },
                                  ]}
                                />
                              </CustomLink>
                            );
                          }
                          return null;
                        })}
                      </div>
                    )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};
ModuloFeatureISR.propTypes = {
  list: PropTypes.array.isRequired,
  taggingInfo: PropTypes.object.isRequired,
};
export default ModuloFeatureISR;
